import cx from 'classnames';
import styles from './Footer.module.scss';

import { NavLink } from 'react-router-dom';

import { PATH } from '@app/index';
import { License } from '@features/License';
import { Typography } from '@shared/Typography';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation('landingPage');

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footerLinks}>
        <img
          alt="logo"
          width={64}
          height={54}
          src="/images/logo.webp"
          className={styles.fLogo}
        />
        <div className={styles.footerColumnFirst}>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('termsOfService')}
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('privacyPolicy')}
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('amlPolicy')}
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('rngLicense')}
          </Typography>
          <NavLink to={PATH.FAQ}>
            <Typography
              component="h1"
              textTransform="uppercase"
              className={cx(styles.fTitle, styles.fTitleCursor)}
            >
              {t('faq')}
            </Typography>
          </NavLink>
        </div>
        <div className={styles.footerColumnSecond}>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('phone')}
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('supportEmail')}
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            {t('complaintsEmail')}
          </Typography>
        </div>
        <div className={styles.footerColumnThird}>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            telegram
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            instagram
          </Typography>
          <Typography component="h1" textTransform="uppercase" className={styles.fTitle}>
            x
          </Typography>
        </div>
      </div>
      <Typography component="h2" variant="secondary" className={styles.fLicense}>
        FairLotto is owned and operated by Fair Play ltd. registration number: 15908,
        registered address: Hamchako, Mutsamudu, Autonomous Island of Anjouan, Union of
        Comoros. Contact us <span>support@fairloto.co</span>. FairLotto is licensed and
        regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros
        and operates under License No. ALSI-202506002 FI1. FairLotto has passed all
        regulatory compliance and is legally authorized to conduct gaming opera ons for
        any and all games of chance and wagering
      </Typography>
      <License />
    </div>
  );
};
